import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Spin, message } from 'antd';
import api from '../../services/api';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import dashboardImage from '../../assets/images/dashboard.jpg';
import {
  UserOutlined,
  UserAddOutlined,
  HourglassOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  SmileOutlined,
  ScheduleOutlined,
  FolderOpenOutlined,
} from '@ant-design/icons';



const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [contentCounts, setContentCounts] = useState(null);

  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await api.get('/admin/dashboard');
     if (response.data.success) {
  setStats({
    totalUsers: response.data.data.totalUsers,
    activeUsers: response.data.data.activeUsers,
    pendingUsers: response.data.data.pendingUsers,
    totalContent: response.data.data.totalContent,
  });

  setContentCounts({
    blogs: response.data.data.blogs,
    testimonials: response.data.data.testimonials,
    stories: response.data.data.stories,
    totalContent: response.data.data.totalContent,
  });
}else {
          throw new Error(response.data.message || 'Failed to load dashboard');
        }
      } catch (error) {
        console.error('Error fetching stats:', error);
        if (error.response?.status === 401) {
          message.error('Session expired. Please login again.');
          navigate('/login');
        } else if (error.response?.status === 403) {
          message.error('You are not authorized to access this page.');
          navigate('/');
        } else {
          message.error(error.message || 'Failed to load dashboard data');
        }
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, [navigate]);

  if (loading) return <Spin size="large" />;

  return (
    <>
      <Helmet>
        <title>Admin Dashboard</title>
      </Helmet>
      
      <Row gutter={16}>
  <Col span={6}>
    <Card title="Total Users" bordered={false}>
      <Row justify="space-between" align="middle">
        <div>{stats?.totalUsers || 0}</div>
        <UserOutlined style={{ fontSize: 24, color: '#1890ff' }} />
      </Row>
    </Card>
  </Col>

  <Col span={6}>
    <Card title="Active Users" bordered={false}>
      <Row justify="space-between" align="middle">
        <div>{stats?.activeUsers || 0}</div>
        <UserAddOutlined style={{ fontSize: 24, color: '#52c41a' }} />
      </Row>
    </Card>
  </Col>

  <Col span={6}>
    <Card title="Pending Approvals" bordered={false}>
      <Row justify="space-between" align="middle">
        <div>{stats?.pendingUsers || 0}</div>
        <HourglassOutlined style={{ fontSize: 24, color: '#faad14' }} />
      </Row>
    </Card>
  </Col>

  <Col span={6}>
    <Card title="Total Content" bordered={false}>
      <Row justify="space-between" align="middle">
        <div>{stats?.totalContent || 0}</div>
        <AppstoreOutlined style={{ fontSize: 24, color: '#722ed1' }} />
      </Row>
    </Card>
  </Col>
</Row>

<Row gutter={16} className="mt-4">
  <Col span={6}>
    <Card title="Total Blogs" bordered={false}>
      <Row justify="space-between" align="middle">
        <div>{contentCounts?.blogs || 0}</div>
        <FileTextOutlined style={{ fontSize: 24, color: '#1890ff' }} />
      </Row>
    </Card>
  </Col>

  <Col span={6}>
    <Card title="Active Testimonials" bordered={false}>
      <Row justify="space-between" align="middle">
        <div>{contentCounts?.testimonials || 0}</div>
        <SmileOutlined style={{ fontSize: 24, color: '#13c2c2' }} />
      </Row>
    </Card>
  </Col>

  <Col span={6}>
    <Card title="Pending Plans" bordered={false}>
      <Row justify="space-between" align="middle">
        <div>{contentCounts?.stories || 0}</div>
        <ScheduleOutlined style={{ fontSize: 24, color: '#fa8c16' }} />
      </Row>
    </Card>
  </Col>

  <Col span={6}>
    <Card title="Total Categories" bordered={false}>
      <Row justify="space-between" align="middle">
        <div>{contentCounts?.totalContent || 0}</div>
        <FolderOpenOutlined style={{ fontSize: 24, color: '#2f54eb' }} />
      </Row>
    </Card>
  </Col>
</Row>
<Row className='mt-4'> 
          <div className='image_dashboard'>
      <img src={dashboardImage} style={{ width: '100%' }} alt="Dashboard" />
      </div></Row>

    </>
  );
};

export default Dashboard;